export default __webpack_public_path__ + "static/media/tanjeaNewsletter.45abae02.svg";